import {
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILURE,
  GET_ONLINE_USERS,
  GET_ONLINE_USERS_SUCCESS,
  GET_ONLINE_USERS_FAILURE,
  GET_PROGRAM_TYPES,
  GET_PROGRAM_TYPES_SUCCESS,
  GET_PROGRAM_TYPES_FAILURE,
  GET_POPULAR_SUBS,
  GET_POPULAR_SUBS_SUCCESS,
  GET_POPULAR_SUBS_FAILURE,
  GET_PROGRAMS,
  GET_PROGRAMS_SUCCESS,
  GET_PROGRAMS_FAILURE,
  GET_VISA_INFO,
  GET_VISA_INFO_SUCCESS,
  GET_VISA_INFO_FAILURE,
  ADD_VISA_INFO,
  ADD_VISA_INFO_SUCCESS,
  ADD_VISA_INFO_FAILURE,
  EDIT_VISA_INFO,
  EDIT_VISA_INFO_SUCCESS,
  EDIT_VISA_INFO_FAILURE,
  DELETE_VISA_INFO,
  DELETE_VISA_INFO_SUCCESS,
  DELETE_VISA_INFO_FAILURE,
  UPLOAD_IMAGE,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILURE,
  UPLOAD_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  GET_PAYMENT_PLANS,
  GET_PAYMENT_PLANS_SUCCESS,
  GET_PAYMENT_PLANS_FAILURE,
  GET_TAGS,
  GET_TAGS_SUCCESS,
  GET_TAGS_FAILURE,
  GET_DIFF_UNI_VALUES,
  GET_DIFF_UNI_VALUES_SUCCESS,
  GET_DIFF_UNI_VALUES_FAILURE,
  ADD_COUNTRY,
  ADD_COUNTRY_SUCCESS,
  ADD_COUNTRY_FAILURE,
  GET_CONTINENTS,
  GET_CONTINENTS_SUCCESS,
  GET_CONTINENTS_FAILURE,
  GET_REGIONS,
  GET_REGIONS_SUCCESS,
  GET_REGIONS_FAILURE,
  EDIT_COUNTRY,
  EDIT_COUNTRY_SUCCESS,
  EDIT_COUNTRY_FAILURE,
} from "../constants";

const initialState = {
  countries: [],
  continents: [],
  regions: [],
  programTypes: [],
  programs: [],
  onlineUsers: [],
  visaInfo: [],
  tags: [],
  popularSubjects: [],
  paymentPlans: [],
  otherValues: {},
  isCountryLoading: false,
  isContinentLoading: false,
  isRegionLoading: false,
  isProgramLoading: false,
  isUploadLoading: false,
  isVisaLoading: false,
  isTagsLoading: false,
  isPopularSubsLoading: false,
  isPaymentPlansLoading: false,
  isOtherValuesLoading: false,
  error: null,
};

export default function OthersReducer(state = initialState, action) {
  switch (action.type) {
    case GET_COUNTRIES:
    case ADD_COUNTRY:
    case EDIT_COUNTRY:
      state = {
        ...state,
        isCountryLoading: true,
        error: null,
      };
      break;
    case GET_CONTINENTS:
      state = {
        ...state,
        isContinentLoading: true,
        error: null,
      };
      break;
    case GET_REGIONS:
      state = {
        ...state,
        isRegionLoading: true,
        error: null,
      };
      break;
    case GET_POPULAR_SUBS:
      state = {
        ...state,
        isPopularSubsLoading: true,
        error: null,
      };
      break;
    case GET_TAGS:
      state = {
        ...state,
        isTagsLoading: true,
        error: null,
      };
      break;
    case GET_PAYMENT_PLANS:
      state = {
        ...state,
        isPaymentPlansLoading: true,
        error: null,
      };
      break;
    case GET_DIFF_UNI_VALUES:
      state = {
        ...state,
        isOtherValuesLoading: true,
        error: null,
      };
      break;
    case GET_ONLINE_USERS:
      state = {
        ...state,
        error: null,
      };
      break;
    case GET_PROGRAM_TYPES:
    case GET_PROGRAMS:
      state = {
        ...state,
        isProgramLoading: true,
        error: null,
      };
      break;
    case GET_VISA_INFO:
    case ADD_VISA_INFO:
    case EDIT_VISA_INFO:
    case DELETE_VISA_INFO:
      state = {
        ...state,
        isVisaLoading: true,
        error: null,
      };
      break;
    case UPLOAD_FILE:
    case UPLOAD_IMAGE:
      state = {
        ...state,
        isUploadLoading: true,
        error: null,
      };
      break;
    case GET_COUNTRIES_SUCCESS:
      state = {
        ...state,
        countries: action?.payload,
        isCountryLoading: false,
      };
      break;
    case ADD_COUNTRY_SUCCESS:
    case EDIT_COUNTRY_SUCCESS:
      state = {
        ...state,
        isCountryLoading: false,
      };
      break;
    case GET_CONTINENTS_SUCCESS:
      state = {
        ...state,
        continents: action?.payload,
        isContinentLoading: false,
      };
      break;
    case GET_REGIONS_SUCCESS:
      state = {
        ...state,
        regions: action?.payload,
        isRegionLoading: false,
      };
      break;
    case GET_PAYMENT_PLANS_SUCCESS:
      state = {
        ...state,
        paymentPlans: action?.payload,
        isPaymentPlansLoading: false,
      };
      break;
    case GET_DIFF_UNI_VALUES_SUCCESS:
      state = {
        ...state,
        otherValues: action?.payload,
        isOtherValuesLoading: false,
      };
      break;
    case GET_POPULAR_SUBS_SUCCESS:
      state = {
        ...state,
        popularSubjects: action?.payload,
        isPopularSubsLoading: false,
      };
      break;

    case GET_TAGS_SUCCESS:
      state = {
        ...state,
        tags: action?.payload,
        isTagsLoading: false,
      };
      break;

    case GET_ONLINE_USERS_SUCCESS:
      state = {
        ...state,
        onlineUsers: action?.payload?.users,
      };
      break;
    case GET_PROGRAM_TYPES_SUCCESS:
      state = {
        ...state,
        programTypes: action?.payload,
        isProgramLoading: false,
      };
      break;
    case GET_PROGRAMS_SUCCESS:
      state = {
        ...state,
        programs: action?.payload,
        isProgramLoading: false,
      };
      break;
    case GET_VISA_INFO_SUCCESS:
      state = {
        ...state,
        visaInfo: action?.payload,
        isVisaLoading: false,
      };
      break;
    case ADD_VISA_INFO_SUCCESS:
    case EDIT_COUNTRY_SUCCESS:
    case DELETE_VISA_INFO_SUCCESS:
      state = {
        ...state,
        isVisaLoading: false,
      };
      break;
    case UPLOAD_FILE_SUCCESS:
    case UPLOAD_IMAGE_SUCCESS:
      state = {
        ...state,
        isUploadLoading: false,
        error: null,
      };
      break;
    case GET_COUNTRIES_FAILURE:
    case ADD_COUNTRY_FAILURE:
    case EDIT_COUNTRY_FAILURE:
      state = {
        ...state,
        isCountryLoading: false,
        error: action.payload,
      };
      break;
    case GET_CONTINENTS_FAILURE:
      state = {
        ...state,
        isContinentLoading: false,
        error: action.payload,
      };
      break;
    case GET_REGIONS_FAILURE:
      state = {
        ...state,
        isRegionLoading: false,
        error: action.payload,
      };
      break;
    case GET_PAYMENT_PLANS_FAILURE:
      state = {
        ...state,
        isPaymentPlansLoading: false,
        error: action.payload,
      };
      break;
    case GET_DIFF_UNI_VALUES_FAILURE:
      state = {
        ...state,
        isOtherValuesLoading: false,
        error: action.payload,
      };
      break;
    case GET_TAGS_FAILURE:
      state = {
        ...state,
        isTagsLoading: false,
        error: action.payload,
      };
      break;
    case GET_PROGRAM_TYPES_FAILURE:
    case GET_PROGRAMS_FAILURE:
      state = {
        ...state,
        isProgramLoading: false,
        error: action.payload,
      };
      break;
    case GET_VISA_INFO_FAILURE:
    case EDIT_VISA_INFO_FAILURE:
    case ADD_VISA_INFO_FAILURE:
    case DELETE_VISA_INFO_FAILURE:
      state = {
        ...state,
        isVisaLoading: false,
        error: action.payload,
      };
      break;
    case GET_POPULAR_SUBS_FAILURE:
      state = {
        ...state,
        isPopularSubsLoading: false,
        error: action.payload,
      };
      break;
    case GET_ONLINE_USERS_FAILURE:
      state = {
        ...state,
        error: action.payload,
      };
      break;
    case UPLOAD_FILE_FAILURE:
    case UPLOAD_IMAGE_FAILURE:
      state = {
        ...state,
        isUploadLoading: false,
        error: null,
      };
      break;
    default:
      break;
  }
  return state;
}
